import { Component, Input } from '@angular/core';

@Component({
    selector: 'mon-data-privacy-severity-level',
    templateUrl: './severity-level.component.html',
    styleUrls: ['./severity-level.component.scss'],
    standalone: false,
})
export class MonDataPrivacySeverityLevelComponent {
    @Input() monPriority: string = '';
}
